import ErrorMessageBlock from '~/components/ErrorMessageBlock';
import Loading from '~/components/Loading';
import { CheckCircleIcon } from '@heroicons/react/24/solid/index';
import FlaskIcon from '~/components/icons/FlaskIcon';
import ExperimentalBadge from '~/components/ExperimentalBadge.jsx';

const IntegrationBlock = ({
    title,
    description,
    icon,
    enabled,
    experimental,
    footer,
    error,
}) => {
    return (
        <div className="panel p-6">
            <div className="flex justify-between items-center">
                <div className="w-8 h-8 mr-3 mb-2 text-primary-700">{icon}</div>
                {enabled && (
                    <div className="text-green-500 bg-green-100 rounded-full px-3 py-1.5 font-medium text-sm uppercase  flex items-center">
                        Enabled
                    </div>
                )}
                {experimental && <ExperimentalBadge />}
            </div>
            <div className="text-lg font-medium">{title}</div>
            <div className="mb-6 mt-1 text-gray-500 leading-tight">
                {description}
            </div>
            {!!error && (
                <ErrorMessageBlock className="mb-4">{error}</ErrorMessageBlock>
            )}
            {footer}
        </div>
    );
};

export default IntegrationBlock;
